import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Called when the user clicks Try Again. */
  onRetry: () => void;
};

/**
 * Full-surface error state for `<ChatboxStuckDetector>`. Replaces the
 * Chatbox when its loading spinner has been showing for too long
 * (silent WS handshake failure). The Try Again button bumps
 * `chatSlice.sessionRetryKey` via the parent's onRetry, which
 * triggers an in-place TalkJS Session recycle — no page refresh, no
 * leaving the meeting. See docs/chat-stuck-spinner-fix-plan.md §5.2.
 */
export function ChatErrorState({ onRetry }: Props) {
  return (
    <div
      className="flex flex-col h-full gap-4 items-center justify-center px-4 py-8 text-center"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col gap-2 items-center max-w-sm">
        <Type variant="h5">Chat couldn't connect</Type>
        <Type variant="body2" className="text-brand-700">
          There was a problem reaching the chat service. You can try again —
          you'll stay in the meeting.
        </Type>
      </div>
      <Button onClick={onRetry}>Try again</Button>
    </div>
  );
}

export default ChatErrorState;
